/* eslint-disable camelcase */
export type InfrontsportsResponse = {
    stream_url: string;
    stream_name: string;
    event_id: string;
};

export type InfrontsportsError = {
    reason: string;
    data: unknown[];
    code: number;
};

export function isInfrontsportsError(input: InfrontsportsResponse | InfrontsportsError): input is InfrontsportsError {
    return Boolean((input as InfrontsportsError).data && (input as InfrontsportsError).code && (input as InfrontsportsError).reason);
}
